// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wb_a bhl_b bhl_we"};